import { render, staticRenderFns } from "./form.vue?vue&type=template&id=3d1d0d22"
import script from "./form.vue?vue&type=script&lang=js"
export * from "./form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3d1d0d22')) {
      api.createRecord('3d1d0d22', component.options)
    } else {
      api.reload('3d1d0d22', component.options)
    }
    module.hot.accept("./form.vue?vue&type=template&id=3d1d0d22", function () {
      api.rerender('3d1d0d22', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/GpsViews/Admin/ShippingInstructions/form.vue"
export default component.exports